<template>
	<div class="note-wrap">
		<div class="note-box">
			<div class="title">新增备忘录</div>
			<div><textarea v-model="form.content"></textarea></div>
			<div class="action"><el-button size="mini" round plain type="primary" :loading="isLoading" @click="saveForm">保存</el-button></div>
		</div>
		<div class="note-list" v-loading="isLoading">
			<div class="title">备忘录</div>
			<div class="no-data" v-if="!list.data || list.data.length == 0">暂无记录</div>

			<div class="note" v-for="item in list.data" :key="item.id">
				<div class="meta">{{item.creator}} | {{item.creatorRole}}
					<span class="date" v-text="item.createTime"></span>
					<el-popconfirm confirmButtonText='删除' title="确定删除吗？" @confirm="delItem(item)">
						<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i class="el-icon-delete" style="color: #f56c6c;"></i></el-tooltip>
					</el-popconfirm>
				</div>
				<div class="content" v-text="item.content"></div>
			</div>
			
		</div>
		<div class="pagination">
			<el-row>
				<el-col :span="12">
					<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
					<div class="record">总计<span v-text="list.total"></span>条记录</div>
				</el-col>
				<el-col :span="12" style="text-align: right;">
					<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';

export default {
	mixins: [mixin],
	props: {
		patientId: {required: true}
	},
	watch: {
		patientId(newV, oldV) {
			if (newV && (newV != oldV)) {
				this.init();
			}
		}
	},	
	data(){
		return {
			noSidebar: true,
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				patientId: '',
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				content: '',
				patientId: ''
			}
		}
	},
	created() {if (this.patientId) {this.init();}},
	methods: {
		init() {this.loadList();},
		async loadList() {
			this.isLoading = true;
			this.filter.patientId = this.patientId;
			let res = await api.getNoteList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		async saveForm() {
			if (this.form.content.trim('') == '') {
				return this.$message.warning('请输入内容');
			}
			this.isLoading = true;
			this.form.patientId = this.patientId;
			let res = await api.addNote(this.form);
			this.isLoading = false;
			if (res.code != 1000) {
				return this.$message.error(res.message);
			}
			this.loadList();
			this.$message.success('保存成功');
			this.form.content = '';
		},
		async delItem(item) {
			let res;
			if (this.isLoading) {return;}
			
			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.delNoteList({patientNoteId: item.id});
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({message: '已删除',type: 'success'});
			this.loadList();
		},
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		}					
	}
}
</script>

<style lang="less">
@import './user-bio.less';
.note-wrap{
	.content {
		white-space: pre-wrap;
	}
}
</style>
